export default "__VITE_ASSET__DADyf5Pu__"